import { BONUS_BY_PRODUCT_CARDS_EN_US } from "#components/bonus-by-product-cards/translations";
import { BONUS_BY_PRODUCT_TABLE_EN_US } from "#components/tables/reports/bonus-by-product-table/translations";

import { merge } from "lodash-es";

export const financialReport = {
	label: "Resume",
	finished: {
		end: "Closed: {{end}}",
		not: "The event has not closed",
	},
	reportIn: "Billing for the event '{{event}}'",
	fileName: "billing-{{event}}",
	tabs: {
		bonusByProduct: merge(
			{
				cards: BONUS_BY_PRODUCT_CARDS_EN_US,
			},
			BONUS_BY_PRODUCT_TABLE_EN_US,
		),
		bonusReport: {
			title: "Bonus",
			description: "See all bonus granting and usage reports",
			filenameBonus: "bonus-granted",
			filenameAnticipated: "anticipated-consumption",
			filenameConsumption: "consumption",
			total: "Total of {{category}}",
			select: "Select a category",
			selectNotFound: "No category found",
			tabs: {
				given: "Bonus Granted",
				used: "Bonus Used",
			},
			columns: {
				client: "Client",
				category: "Category",
				date: "Date",
				reason: "Reason",
				receivedValue: "Received Value",
				spentValue: "Spent Value in the event",
				spentValueInOtherEvents: "Spent Value in other events",
				givenBy: "Given by",
				total: "Total",
			},
		},
	},
};
